import React from "react";
export function StaticImage(props) {
  const { name, value, label, options, tagName, validation, prefix, ...rest } =
    props;
  const id = `${tagName}-input`;
  return (
    <>
      <div className="flex-container">

        <div
          align="left"
          style={{ padding: "0px 16px 0px 0px", margin: 1 }}
          autoComplete="off"
        >
          <div aria-labelledby={id}>
            <img
              alt={name}
              src={
                process.env.REACT_APP_SITE_URL +
                `/Pages/Utils/ShowImage.ashx?Category=${props.category}&ImageID=${props.imageId}`
              }
            />
          </div>
        </div>
      </div>
    </>
  );
}
